$(function () {
	let inputMask = function() {
		$('.js-input-mask').each(function () {
			const mask = $(this).data('mask');
			
			// Очищаем предыдущую маску если была
			if ($(this).data('inputmask')) {
				$(this).inputmask('remove');
			}
			
			new Inputmask({
				mask: mask,
				placeholder: '_',
				showMaskOnHover: false,
				showMaskOnFocus: false,
				clearMaskOnLostFocus: true, 
				clearIncomplete: true,
				autoUnmask: true,
				removeMaskOnSubmit: true,
				// Специальные настройки для мобильных
				inputmode: 'numeric',
				// Задержка для предотвращения конфликтов
				onBeforeMask: function(value, opts) {
					return value;
				}
			}).mask(this);
			
			// Дополнительная обработка для мобильных
			$(this).on('touchstart', function(e) {
				e.stopPropagation();
			});
		});
	}
	
	inputMask();
	window.inputMask = inputMask;
});